import { render, staticRenderFns } from "./DescriptionModal.vue?vue&type=template&id=2b94bb32&scoped=true&"
import script from "./DescriptionModal.vue?vue&type=script&lang=js&"
export * from "./DescriptionModal.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionModal.vue?vue&type=style&index=0&id=2b94bb32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b94bb32",
  null
  
)

export default component.exports